export default class DashboardExchangeBankTypeModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
  }
}
